<app-header></app-header>
<router-outlet></router-outlet>
<app-footer [isDark]="isDarkFooter"></app-footer>
